export default "__VITE_ASSET__f00b9b9d__"